import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

/**
 * Iter-32 — Callback OAuth Google direct (sans intermédiaire Emergent).
 *
 * Google redirige vers /auth/google?code=...&state=...
 * On échange le code côté backend → cookie session → redirection dashboard/asso-admin.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleCallback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;

        const error = params.get("error");
        if (error) {
            navigate(`/login?error=${encodeURIComponent(error)}`, { replace: true });
            return;
        }
        const code = params.get("code");
        if (!code) {
            navigate("/login", { replace: true });
            return;
        }

        const redirectUri = `${window.location.origin}/auth/google`;
        (async () => {
            try {
                const { data } = await api.post("/auth/google/exchange", {
                    code,
                    redirect_uri: redirectUri,
                });
                const me = await api.get("/auth/me");
                setUser(me.data);
                if (data.role === "association") {
                    navigate("/asso-admin", { replace: true });
                } else if (data.role === "candidate") {
                    // Iter-34 — auto-inscription Google : complétion profil + attente validation
                    navigate("/candidate-waiting", { replace: true });
                } else if (
                    (data.role === "learner" || data.role === "manager") &&
                    data.onboarding_completed === false
                ) {
                    navigate("/onboarding", { replace: true });
                } else {
                    navigate("/dashboard", { replace: true });
                }
            } catch (e) {
                const detail = e?.response?.data?.detail;
                const reason = typeof detail === "string"
                    ? detail
                    : "Échec de la connexion Google. Réessaie.";
                navigate(`/login?error=${encodeURIComponent(reason)}`, { replace: true });
            }
        })();
    }, [params, navigate, setUser]);

    return (
        <div
            data-testid="google-callback-loading"
            className="min-h-screen flex items-center justify-center bg-shariti-deep-black"
        >
            <div className="text-center space-y-4">
                <div className="w-12 h-12 rounded-full border-4 border-shariti-orange border-t-transparent animate-spin mx-auto" />
                <p className="text-white/70 font-light">Connexion en cours…</p>
            </div>
        </div>
    );
}
